/* eslint-disable max-len */
/* Note: this file is generated by "npm run template", please dont modify this file directly */
/* -- instead, you should modify "static-files/gant-legacy/.prettierrc" and run "npm run template" */
import { ResultFile } from "@gant-lowcode/lowcode-types";

export default function getFile(): [string[], ResultFile] {
  return [
    ["."],
    {
      name: ".prettierrc",
      ext: "",
      content:
        '{\n  "singleQuote": true,\n  "trailingComma": "all",\n  "printWidth": 80,\n  "overrides": [\n    {\n      "files": ".prettierrc",\n      "options": { "parser": "json" }\n    }\n  ]\n}\n',
    },
  ];
}
